/**
 * affiliate Affiliate Management JS
 *
 * @copyright 2013, Aussie Sim
 *
 * @version 1.00
 * @author Simplisite <developer@simplisite.com.au>
 */
function Documents() {
    return {
        theGridView: false,
        /**
         * Init
         */
        init: function() {
            var self = this;

            //add the grid
            this.createGridView();

            $('#search-form').submit(function() {
                self.reload();
                return false;
            });
        },

        /**
         * Generate and store a reference to a new KendoGrid
         */
        createGridView: function() {
            if (typeof window.notificationsGrid !== 'undefined') {
                $('#notifications-grid').kendoGrid({
                    dataSource: window.notificationsGrid,
                    filterable: true,
                    sortable: true,
                    pageable: true,
                    pageable: {
                        pageSize: 10
                    },
                    dataBound: function(e) {
                        $('#notifications-grid .edit-btn').click(function() {
                            window.location =
                                '/' +
                                URLSEGMENT +
                                '/editaffiliatenotification/' +
                                $(this).attr('data-record-id') +
                                '/?rm=notifications';
                            return false;
                        });
                    },
                    columns: [
                        {
                            title: 'Unread',
                            width: '100px',
                            template:
                                '# if(data.HasBeenViewed == 0) { #' + '<span class="unread-indicator"></span>' + '# } #'
                        },
                        {
                            field: 'GetDisplayType',
                            title: 'Type',
                            width: '200px'
                        },
                        // {
                        //     field: 'Status',
                        //     title: "Status",
                        //     width: "200px"
                        // },
                        {
                            field: 'Subject',
                            title: 'Subject',
                            template:
                                '# if(data.Subject) { #' +
                                '<a href="/affiliate/editnotification/${ ID }">#= data.Subject #</a>' +
                                '# } else { #' +
                                '<a href="/affiliate/editnotification/${ ID }">No Subject</a>' +
                                '# } #',
                            width: '250px'
                        }
                        // {
                        //     filterable: false,
                        //     title: "",
                        //     width: '200px',
                        //     template: '<a href="editnotification/${ ID }" data-record-id="${ ID }" class="edit-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" ' +
                        //     'viewBox="0 0 24 24"><path d="M7.5 21l-6.5 2 2-6.5 12-12 4.5 4.5zM15 4.5l3.086-3.085c.' +
                        //     '778-.778 2.05-.778 2.828 0l1.672 1.671c.778.779.778 2.051 0 2.829l-3.086 3.085M17.25 6.75l-10.75 10.75M3 16.5l1 1h2.5v2.5l1 1M2 20l2 2M16.5 3l4.5 4.5" ' +
                        //     'stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></svg></a>'
                        // }
                    ],
                    dataBound: function(e) {
                        var rows = e.sender.tbody.children();

                        for (var j = 0; j < rows.length; j++) {
                            var row = $(rows[j]);
                            var dataItem = e.sender.dataItem(row);

                            if (dataItem.get('HasBeenViewed') == 0) {
                                row.addClass('unread-message');
                            }
                        }
                    }
                });

                this.theGridView = $('#notifications-grid').data('kendoGrid');
            }
        },

        /**
         * Refresh the insights dashboard (usually called after the drop-downs are changed)
         */
        reload: function() {
            //reload the chart
            this.theGridView.dataSource.read();
            this.theGridView.refresh();
        },

        /**
         * Resize Handler
         */
        onresize: function() {
            const grid = $('#notifications-grid');
            if (grid.length) {
                grid.height((window.innerHeight - 60) * 0.8);
                if (grid.data('kendoGrid')) {
                    grid.data('kendoGrid').refresh();
                }
            }
        }
    };
}

/**
 * Initialise
 */
var SC;
$(document).ready(function() {
    SC = new Documents();

    SC.init();

    window.onresize = SC.onresize;
});
